export const setAddCharts = (data) => {
  return {
    type: 'ADD_CHARTS',
    payload: {
      data
    }
  };
};
